import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tocList", "btnMore", "btnClose"];

  connect() {
    this.btnMoreTarget.style.display = "flex";
    this.btnCloseTarget.style.display = "none";
  }

  open(e) {
    e.preventDefault();

    this.tocListTarget.classList.add("opened");
    this.btnMoreTarget.style.display = "none";
    this.btnCloseTarget.style.display = "flex";
  }

  close(e) {
    e.preventDefault();

    this.tocListTarget.classList.remove("opened");
    this.btnMoreTarget.style.display = "flex";
    this.btnCloseTarget.style.display = "none";

    const toc = document.querySelector(".toc");
    if (toc) {
      const tocTop = toc.getBoundingClientRect().top + window.pageYOffset;
      const header = document.querySelector(".header");
      const headerHeight = header ? header.offsetHeight : 0;
      const categoryNav = document.querySelector(".category-nav__wrap");
      const categoryNavHeight = categoryNav ? categoryNav.offsetHeight : 0;
      const tocMarginTop = toc ? parseFloat(getComputedStyle(toc).marginTop) : 0;
      window.scrollTo({
        top: tocTop - headerHeight - categoryNavHeight - tocMarginTop,
        behavior: "smooth"
      });
    }
  }
}
